import { $api } from "./index";
import { ICart } from "../types/entities";

export const updateQuantity = async (
    productId: number,
    quantity: number,
    priceOptionVolume?: string | null
) => {
    const { data } = await $api.put<ICart>('/cart', {
        productId,
        quantity,
        priceOptionVolume: priceOptionVolume ?? undefined,
    });

    return data;
}; 